class Branche {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-branche="scope"]',
			input: '[data-branche="input"]',
			select: '[data-branche="select"]',
			count: '[data-branche="count"]',
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.addEventListeners();

		this.$scope.each((index, element) => {
			let $scope = $(element);
			this.changeCount($scope.find('form'));
		})
	}

	addEventListeners() {
		$(document).off('.branche')
			.on('change.branche', `${this.config.scope} :input`, event => this.changeCount($(event.currentTarget).closest('form')))
			.on('change.branche', `${this.config.scope} ${this.config.select}`, this.setValue.bind(this));
	}

	setValue(event) {
		let $select = $(event.currentTarget);
		let $scope = $select.closest(this.config.scope);
		let $option = $select.find('option:selected');
		let $input = $scope.find(this.config.input);

		if($option.hasClass('first-option')) {
			$input.removeAttr('name');
			$input.removeAttr('value', false);
		} else {
			$input.attr('name', $option.data('name'));
			$input.val($option.attr('value'));
		}

		this.changeCount($input.closest('form'));
	}

	changeCount($form) {
		let formdata = $form.serializeObject();
		formdata['action'] = 'search-job-count';

		$.ajax({
			url: $form.attr('action'),
			data: formdata,
			success: (response) => {
				$form.closest(this.config.scope).find(this.config.count).html(response.count);
			}
		});
	}
}

export default new Branche;